import React from 'react';
import {
    withStyles,
    Grid,
    ButtonBase,
    Typography,
    ListItem,
    Avatar,
    Divider,
} from '@material-ui/core';

const ICONS = [
    require('../../images/icons/icon_txl.png'),
    require('../../images/icons/icon_qunliao.png'),
    require('../../images/icons/icon_tjhy.png')
];

class ChatItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    _onListItemClick = () => {
        this.props.onClick && this.props.onClick();
    }

    render() {
        const { classes, title, icon, divider, showPoint } = this.props;
        let iconImg = ICONS[icon];
        return (
            <ListItem disableRipple button onClick={() => this._onListItemClick()} className={classes.root}>
                <Grid container direction='row' alignItems='center' style={{ flex: 1 }}>
                    <Grid container direction='row' alignItems='center' style={{ paddingLeft: 8 }}>
                        <Grid container direction='row' style={{ width: 46 }}>
                            <Avatar src={iconImg} className={classes.menuIcon} />
                            {showPoint && <Grid style={{ width: 6, height: 6, borderRadius: 3, backgroundColor: '#FF0000' }}></Grid>}
                        </Grid>
                        <Typography style={{ color: '#0D0D0D', fontSize: 14, marginLeft: 10 }}>{title}</Typography>
                    </Grid>
                    {
                        !divider && <Grid container direction='column' justifycontent='flex-end' className={classes.content}>
                            <Divider className={classes.divider}></Divider>
                        </Grid>
                    }
                </Grid>
            </ListItem>
        );
    }
}
export default withStyles((theme) => ({
    root: {
        margin: theme.spacing(0.5, 0, 0.5, 0),
        padding: 0,
    },
    menuIcon: {
        width: 40,
        height: 40,
    },
    content: {
        alignItems: 'flex-start',
    },
    divider: {
        backgroundColor: '#FAFAFA',
        height: 1,
        width: 'calc(100% - 56px)',
        marginTop: 8,
        marginLeft: 56
    }

}))(ChatItem);
